export default __webpack_public_path__ + "static/media/logo.33e2aa46.jpeg";